const EntityNames = ["7110 - omnet", "8130 - trkkn", "7150 - omg outcomes", "7120 - fan connect", "7130 - creo", "4155 - comfluence enhanced value serv us"];
const EntitiesAlongWithAgency = ["2110 - omd usa"];
const AgencyNames = ["omg creo", "fan connect"];
const ADCountries = ["Canada", "Colombia", "India", "United States"]
export {
    EntityNames,
    AgencyNames,
    EntitiesAlongWithAgency,
    ADCountries
};